import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
var _excluded = ["ariaLabel"];
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018,2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Spinner } from '@govhhs/govhhs-design-system-react';
import translations from './AppSpinnerMessages';
var AppSpinner = function AppSpinner(_ref) {
  var ariaLabel = _ref.ariaLabel,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var intl = useIntl();
  var formattedAriaLabel = ariaLabel !== '' ? ariaLabel : intl.formatMessage(translations.loading);

  // eslint-disable-next-line no-restricted-syntax
  return /*#__PURE__*/React.createElement(Spinner, _extends({
    ariaLabel: formattedAriaLabel,
    block: true
  }, otherProps));
};
AppSpinner.propTypes = process.env.NODE_ENV !== "production" ? {
  ariaLabel: PropTypes.string
} : {};
AppSpinner.defaultProps = {
  ariaLabel: ''
};
export default AppSpinner;